import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "smartphoneFilled"
const SmartphoneFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12 18C12.621 18 13.125 18.504 13.125 19.125S12.621 20.25 12 20.25 10.875 19.746 10.875 19.125 11.379 18 12 18" />
          <path
            fillRule="evenodd"
            d="M17.25 1.5C18.078 1.5 18.75 2.172 18.75 3V21C18.75 21.828 18.078 22.5 17.25 22.5H6.75L6.597 22.492Q6.522 22.484 6.449 22.469L6.42 22.462Q6.367 22.45 6.314 22.435L6.242 22.41 6.182 22.387 6.116 22.357Q6.084 22.344 6.052 22.328 6.022 22.311 5.993 22.293L5.93 22.256 5.878 22.218 5.816 22.173 5.77 22.133Q5.738 22.108 5.708 22.078L5.668 22.04 5.614 21.977 5.576 21.932 5.526 21.866 5.493 21.815 5.454 21.755Q5.438 21.724 5.421 21.696L5.384 21.617 5.362 21.57Q5.346 21.53 5.332 21.486L5.314 21.434Q5.301 21.39 5.29 21.342L5.28 21.294Q5.25 21.15 5.25 21V3C5.25 2.172 5.922 1.5 6.75 1.5zM6.75 20.25C6.75 20.664 7.086 21 7.5 21H16.5C16.914 21 17.25 20.664 17.25 20.25V17.25H6.75zM10.5 3.75C10.086 3.75 9.75 4.086 9.75 4.5S10.086 5.25 10.5 5.25H13.5C13.914 5.25 14.25 4.914 14.25 4.5S13.914 3.75 13.5 3.75z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default SmartphoneFilledIcon
